import React from 'react';
import { CategoryList } from './apiService';
import { Link, Row, Tag } from './styles';
import { TagProps } from './styles/Tag';
import { getCategoryUrl, getGenres, getGenreTitles } from './utils';
import { SpacingProps } from './withStyleSystem';

type ContentGenresProps = {
  categories?: CategoryList[];
  link?: boolean;
  color?: TagProps['color'];
  nowrap?: boolean;
  textOnly?: boolean;
  limit?: number;
} & SpacingProps;

export default function ContentGenres({ categories, link = true, color, nowrap, textOnly, limit, ...styleSystem }: ContentGenresProps) {
  if (textOnly) return <>{getGenreTitles(categories, limit)}</>;

  return (
    <Row {...styleSystem} nowrap={nowrap}>
      {getGenres(categories, limit)?.map((genre) => (
        <Tag key={genre.title} as={link ? Link : 'div'} href={link ? getCategoryUrl(genre) : undefined} color={color}>
          {genre.title}
        </Tag>
      ))}
    </Row>
  );
}
